export default {
  dashboard: {
    actions: {
      view: true
    },
    numericalOrder: 1,
    description: "Giám sát hệ thống"
  },
  dashboard_2: {
    actions: {
      view: true,
    },
    numericalOrder: 2,
    description: "Giám sát tổng quan"
  },
  monitoring: {
    actions: {
      view: true,
      control: false,
      camera: false,
      chart: false,
      map: false,
      images: false,
      infoStation: false,
      reviewStation: false
    },
    numericalOrder: 3,
    description: "Giám sát trực tuyến"
  },
  monitorByList: {
    actions: {
      view: true
    },
    numericalOrder: 4,
    description: "Giám sát danh sách"
  },
  map: {
    actions: {
      view: true
    },
    numericalOrder: 5,
    description: "map"
  },
  camera: {
    actions: {
      view: true
    },
    numericalOrder: 5,
    description: "camera"
  },
  chart: {
    actions: {
      view: true,
      export: false
    },
    numericalOrder: 5.1,
    description: "chart"
  },
  dataSearch: {
    actions: {
      view: true,
      export: false
    },
    numericalOrder: 6,
    description: "Tra cứu dữ liệu"
  },
  avgSearch: {
    actions: {
      view: true,
      export: false
    },
    numericalOrder: 7,
    description: "Dữ liệu trung bình"
  },
  xuLyDuLieu_config: {
    actions: {
      view: true,
    },
    numericalOrder: 8,
    description: "Xử lý dữ liệu - Cấu hình"
  },
  kiemDuyetDuLieu: {
    actions: {
      view: true,
      export: false
    },
    numericalOrder: 9,
    description: "Kiểm duyệt dữ liệu"
  },
  qaqcConfig: {
    actions: {
      view: true,
      publicStation: false
    },
    numericalOrder: 10,
    description: "Cấu hình chia sẻ dữ liệu"
  },
  ftpTransfer: {
    actions: {
      view: true,
      isTransfer: false,
      updateFTP: false
    },
    numericalOrder: 11,
    description: "Cấu hình truyền FTP"
  },
  shareAPI: {
    actions: {
      view: true,
    },
    numericalOrder: 11.1,
    description: "Chia sẻ API"
  },
  tiLeDuLieuThuDuoc: {
    actions: {
      view: true,
      export: false
    },
    numericalOrder: 12,
    description: "Tỉ lệ dữ liệu thu được"
  },
  tb24H: {
    actions: {
      view: true,
      export: false
    },
    numericalOrder: 14,
    description: "Trung bình 24 giờ"
  },
  tb1H: {
    actions: {
      view: true,
      export: false
    },
    numericalOrder: 15,
    description: "Trung bình 1 giờ"
  },
  tb1HMax: {
    actions: {
      view: true,
      export: false
    },
    numericalOrder: 16,
    description: "Trung bình 1h Max"
  },
  tb8HMax: {
    actions: {
      view: true,
      export: false
    },
    numericalOrder: 17,
    description: "Trung bình 8h Max"
  },

  tileDuLieuVuotNguong: {
    actions: {
      view: true,
      export: false
    },
    numericalOrder: 18,
    description: "Tỉ lệ dữ liệu vượt ngưỡng"
  },
  soLanMatKetNoi: {
    actions: {
      view: true,
      export: false
    },
    numericalOrder: 19,
    description: "Số lần mất kết nối"
  },
  aqiGio: {
    actions: {
      view: true,
      export: false
    },
    numericalOrder: 20,
    description: "AQI - giờ"
  },
  aqiNgay: {
    actions: {
      view: true,
      export: false
    },
    numericalOrder: 21,
    description: "AQI - ngày"
  },
  wqiGio: {
    actions: {
      view: true,
      export: false
    },
    numericalOrder: 22,
    description: "WQI - giờ"
  },
  wqiNgay: {
    actions: {
      view: true,
      export: false
    },
    numericalOrder: 22.1,
    description: "WQI - ngày"
  },
  wqiPeriodic: {
    actions: {
      view: true,
      export: false
    },
    numericalOrder: 22.2,
    description: "WQI - đinh kì"
  },
  tinhTrangDuLieu: {
    actions: {
      view: true,
      export: false
    },
    numericalOrder: 23,
    description: "Tình trạng dữ liệu"
  },
  aqiMap: {
    actions: {
      view: true
    },
    numericalOrder: 24,
    description: "Bản đồ AQI"
  },
  wqiMap: {
    actions: {
      view: true
    },
    numericalOrder: 25,
    description: "Bản đồ WQI"
  },
  configWQI: {
    actions: {
      view: true,
    },
    numericalOrder: 26,
    description: "Cấu hình tính WQI, AQI"
  },
  
  stationFixPhase: {
    actions: {
      view: true,
      create: true,
      edit: true,
      delete: true
    },
    numericalOrder: 27,
    description: "Quản lý đợt quan trắc"
  },
  stationFix: {
    actions: {
      view: true,
      create: true,
      edit: true,
      delete: true
    },
    numericalOrder: 28,
    description: "Quản lý điểm quan trắc"
  },
  stationFixInput: {
    actions: {
      view: true,
    },
    numericalOrder: 29,
    description: "Nhập liệu điểm quan trắc"
  },
  stationFixData: {
    actions: {
      view: true,
      export: false
    },
    numericalOrder: 30,
    description: "Tra cứu dữ liệu điểm quan trắc"
  },
  stationFixMap: {
    actions: {
      view: true
    },
    numericalOrder:  30.1,
    description: "Bản đồ điểm quan trắc"
  },
  stationAuto: {
    actions: {
      view: true,
      create: false,
      edit: false,
      delete: false
    },
    numericalOrder: 31,
    description: "Trạm quan trắc"
  },
  cauHinhKetNoi: {
    actions: {
      view: true,
      fileMapping: false
    },
    numericalOrder: 32,
    description: "Cấu hình kết nối"
  },
  cauHinhGuiCanhBao: {
    actions: {
      view: true,
    },
    numericalOrder: 33,
    description: "Cấu hình gửi cảnh báo"
  },
  cauHinhLayMau: {
    actions: {
      view: true,
    },
    numericalOrder: 34,
    description: "Cấu hình lấy mẫu"
  },
  cauHinhTinhToanAQI: {
    actions: {
      view: true,
    },
    numericalOrder: 35,
    description: "Cấu hình tính toán AQI"
  },
  cauHinhTinhToanWQI: {
    actions: {
      view: true,
    },
    numericalOrder: 36,
    description: "Cấu hình tính toán WQI"
  },
  cauHinhCamera: {
    actions: {
      view: true,
      updateSelectStation: false,
      create: false,
      edit: false,
      delete: false
    },
    numericalOrder: 37,
    description: "Cấu hình Camera"
  },
  measuring: {
    actions: {
      view: true,
      create: false,
      edit: false,
      delete: false
    },
    numericalOrder: 38,
    description: "Chỉ tiêu quan trắc"
  },
  stationType: {
    actions: {
      view: true,
      create: false,
      edit: false,
      delete: false
    },
    numericalOrder: 39,
    description: "Loại trạm"
  },
  province: {
    actions: {
      view: true,
      create: false,
      edit: false,
      delete: false
    },
    numericalOrder: 40,
    description: "Đơn vị quản lý"
  },
  qcvn: {
    actions: {
      view: true,
      create: false,
      edit: false,
      delete: false
    },
    numericalOrder: 41,
    description: "Quy chuẩn"
  },
  service_config: {
    actions: {
      view: true,
      setup:false
    },
    numericalOrder: 41.1,
    name: "Cấu hình dịch vụ"
  },
  role: {
    actions: {
      view: true,
      create: false,
      edit: false,
      delete: false
    },
    numericalOrder: 42,

    description: "Nhóm quyền"
  },
  user: {
    actions: {
      view: true,
      create: false,
      edit: false,
      delete: false,
      role: false,
      enableAccount: false
    },
    numericalOrder: 43,
    description: "Người dùng"
  },
  config_color_noti: {
    actions: {
      view: true,
    },
    numericalOrder: 43,
    description: "Cấu hình màu cảnh báo"
  },
  xem_Nhat_ky: {
    actions: {
      view: true,
    },
    numericalOrder: 43,
    description: "Xem nhật ký"
  },
  mobile_dashboard: {
    actions: {
      view: true,
      statistics_device: false,
      statistics_exceeded_avgDay: false
    },
    numericalOrder: 44,
    name: "Trang chủ Mobile"
  },
  
};



// WEBPACK FOOTER //
// ./src/constants/menu.js